<template>
  <div class="mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-12 banner-title">
            <i class="material-icons md-36" @click="goBack">keyboard_arrow_left</i>
            <span class="title-text" v-if="isLogin" @click="goBack">{{ $t('message.login') }}</span>
            <span class="title-text" v-else @click="goBack">{{ $t('message.forgotPassword') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-md-9 bg-white py-4">
        <form class="pt-2 pb-4 d-flex flex-wrap justify-content-center" @submit.prevent="submit">
          <h3
            class="w-75 mb-5 mt-4 d-flex justify-content-center"
            v-if="isLogin"
          >{{ $t('message.signInToYourAccount') }}</h3>
          <h3
            class="w-75 mb-5 mt-4 d-flex justify-content-center"
            v-else
          >{{ $t('message.forgotPassword') }}</h3>
          <div class="form-group w-75">
            <label for="exampleInputEmail1">{{ $t('message.email') }}</label>
            <input
              v-validate="'required|email'"
              id="exampleInputEmail1"
              v-model="email"
              type="text"
              name="email"
              class="form-control"
              aria-describedby="emailHelp"
            />
            <div class="invalid-feedback">{{ OOErrors.first("email") }}</div>
          </div>
          <div class="form-group w-75" v-if="isLogin">
            <label for="exampleInputPassword1">{{ $t('message.password') }}</label>
            <input
              v-validate="'required'"
              id="exampleInputPassword1"
              v-model="password"
              type="password"
              name="password"
              class="form-control"
            />
            <div class="invalid-feedback">{{ OOErrors.first("password") }}</div>
          </div>
          <div class="w-75 mt-1" v-if="isLogin">
            <a
              href="#"
              @click="switchView(false)"
              :style="mobileStyles.LinkColorTxt"
              style="float: right;margin-top: -0.875rem;"
            >{{ $t('message.forgotPassword') }}?</a>
          </div>
          <div class="w-75 mt-1" v-else>
            <a
              href="#"
              @click="switchView(true)"
              style="float: right;margin-top: -0.875rem;"
              :style="mobileStyles.LinkColorTxt"
            >{{ $t('message.login') }}</a>
          </div>
          <div class="w-75 justify-content-center mt-4">
            <p
              v-html="$t('message.termsOfUsePrivacyStatement')"
              style="font-size:0.6875rem;line-height: 1.4;text-align: center;"
            ></p>
          </div>
          <div class="w-75 d-flex justify-content-between">
            <button
              v-if="isLogin"
              :disabled="loading"
              type="submit"
              class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
              :style="mobileStyles.btn"
            >
              {{ $t('message.signIn') }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
            <button
              v-else
              :disabled="loading"
              type="submit"
              class="btn btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center fs-1 fw-600"
              :style="mobileStyles.btn"
            >
              {{ $t('message.sendLink') }}
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>
          <div class="w-75 mt-5 mb-5 d-flex justify-content-center">
            {{ $t('message.haventGotAnAccount') }} ? &nbsp;
            <a
              href="#"
              :style="mobileStyles.LinkColorTxt"
              @click="gotoRegister()"
            >{{ $t('message.register') }}</a>
          </div>
          <div v-if="FacebookLogin || GoogleLogin" class="w-75 mb-3 d-flex justify-content-center">
            <strong>{{ $t('message.orSignInWith') }}</strong>
          </div>
          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
          <div v-show="msg" class="w-75 mt-4">
            <div class="alert alert-success" role="alert">
              <strong>{{ msg }}</strong>
            </div>
          </div>

          <div class="container" v-if="isLogin">
            <div class="row mb-4 justify-content-center">
              <auth-providers-login />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import shared from "../../sharedscripts/user/login.js";
import AuthProvidersLogin from "./AuthProvidersLogin";

export default {
  components: {
    AuthProvidersLogin
  },
  data() {
    return {
      isLogin: true,
      email: "",
      password: "",
      loading: false,
      error: "",
      msg: "",
      returnComponent: "store"
    };
  },
  props: {
    storeid: {
      type: String,
      default: null
    },
    forgift: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["currentStoreDoc", "mobileStyles", "viewConfig"]),
    FacebookLogin() {
      return this.viewConfig.FacebookLogin;
    },
    GoogleLogin() {
      return this.viewConfig.GoogleLogin;
    }
  },
  beforeRouteEnter(to, from, next) {
    var fromName = from.name;
    next(vm => {
      if (fromName) vm.$data.returnComponent = fromName;
    });
  },
  methods: {
    ...shared.methods,
    goBack() {
      this.$router.push({
        name: this.returnComponent,
        params: {
          storeid: this.currentStoreDoc.ID,
          storename: this.currentStoreDoc.Name
        }
      });
    },
    gotoRegister() {
      this.$router.push({
        name: "registeruser"
      });
    }
  }
};
</script>
